import { useQuery } from "@apollo/client";

import { ALLSTAR_COMMAND_FEED } from "MVVM/GraphQL/allstarCommandFeed";
import { ContentFeed } from "MVVM/Views/Homepage/ContentFeed";
import { IContentItem } from "MVVM/Views/Homepage/@types";

import { FEED } from "../data";
import { CommandMark, Section, SectionHeading } from "../../styledComponents";

// ContentFeed puts anything past its 7-per-row max behind a "See More" toggle.
// The row already scrolls, so ask for exactly one row and skip the toggle.
const FEED_LIMIT = 7;

// ContentFeed tags its analytics and its clip modal with this.
const FEED_TITLE = "Clipped with !allstar";

export const Feed = () => {
  const { data, loading } = useQuery(ALLSTAR_COMMAND_FEED, {
    variables: { limit: FEED_LIMIT },
    fetchPolicy: "cache-and-network",
  });

  const clips: IContentItem[] = data?.clips?.nodes ?? [];

  // ContentFeed already renders nothing for an empty feed, but the section
  // padding would still leave a gap, so drop the whole band here.
  if (!loading && !clips.length) return null;

  return (
    <Section py={[72, 96, 120]}>
      <ContentFeed
        title={FEED_TITLE}
        titleNode={
          <SectionHeading>
            {FEED.headingLead}
            <CommandMark>{FEED.headingUnderlined}</CommandMark>
          </SectionHeading>
        }
        description={FEED.subheading}
        data={clips}
        loading={loading}
        vanillaThumbnail
      />
    </Section>
  );
};
